import { create, el } from "@dhx/ts-common/dom";
import { View } from "@dhx/ts-common/view";

export class Fields extends View {
	constructor(element?: string | HTMLElement, config: any = {}) {
		super(element, config);

		const render = () => this._render();
		this.mount(element, create({ render }));
	}

	private _render() {
		return el(`.dhx_config_${this.config.item}`, { ...this.config.events }, [
			this.config.configurator.getField(this.config.item),
		]);
	}
}
